import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Liberación de la Carga Mental',
    desc: 'Abre el cofre, elige el tomo según tu clase y enseña. La planificación ya está hecha.'
  }, {
    emoji: '👑',
    title: 'Autoridad y Confianza',
    desc: 'Con clases validadas, llegas al estudio con la postura de una experta y las palabras justas para guiar.'
  }, {
    emoji: '🌿',
    title: 'Progresión Real de los Alumnos',
    desc: 'Secuencias que respetan la biomecánica para que tus alumnos noten resultados y no abandonen.'
  }, {
    emoji: '😌',
    title: 'Cero Estrés de Transición',
    desc: 'Domina el arte de conectar los ejercicios para un Flow perfecto que impresionará a tus clientes.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-12" data-id="element-17">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-18">
            LO QUE VA A CAMBIAR
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-19">
            Lo que va a cambiar en tu{' '}
            <span className="italic text-pilates-rose" data-id="element-20">vida profesional</span>
          </h2>
          <p className="text-pilates-slate text-lg max-w-2xl mx-auto" data-id="element-21">
            Los beneficios reales desde la primera semana:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-22">
          {benefits.map((b, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/15 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-23">
              <div className="text-4xl mb-3" data-id="element-24">{b.emoji}</div>
              <h3 className="font-display font-semibold text-pilates-dark text-xl mb-2 leading-tight" data-id="element-25">
                {b.title}
              </h3>
              <p className="text-pilates-slate text-base leading-relaxed" data-id="element-26">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}